<div class="flex flex-col justify-between flex-1">
  @if (!lightMode()) {
    @if (!product().prismicTable?.length) {
      <ngx-dynamic-hooks
        class="text-center flex-auto text-[--color-text-secondary] text-sm font-medium"
        [content]="product().short_description"
        [options]="{ sanitize: false }"
      />
    }
    <lib-product-box-features [product]="product()" />
  }
</div>
